<template>
    <div id="configuration">
        <div class="app-container my-5">
            <div class="mt-5">
                <h2 class="">Configuration générale</h2>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-start flex-wrap w-100">

                        <v-hover v-slot="{ hover }">
                            <v-card to="/configuration/business" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>business</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Ma structure</h4>
                                    <div class="d-flex gap-10 flex-wrap">
                                        <div class="badge bg-light">Nom de l'organisme</div>
                                        <div class="badge bg-light">CGU</div>
                                        <div class="badge bg-light">Logo</div>
                                    </div>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }">
                            <v-card to="/configuration/team" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>group</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mon équipe</h4>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }">
                            <v-card to="/configuration/contracts" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>assignment</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes contrats</h4>
                                    <div class="d-flex gap-10 flex-wrap">
                                        <div class="badge bg-light">Abonnement</div>
                                        <div class="badge bg-light">Campagnes</div>
                                    </div>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }">
                            <v-card to="/configuration/tags" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>bookmarks</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes tags</h4>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }">
                            <v-card to="/configuration/invoice-config" :elevation="hover ? 4 : 2" v-if="hasInvoiceOffer()">
                                <div class="card-header text-center">
                                    <v-icon x-large>request_quote</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mon outil de facturation d'adhésion</h4>
                                    <div class="d-flex gap-10 flex-wrap">
                                        <div class="badge bg-light">Titre des factures</div>
                                        <div class="badge bg-light">Numéro de facture</div>
                                        <div class="badge bg-light">Informations de facturation</div>
                                        <div class="badge bg-light">Espace textes</div>
                                    </div>
                                </div>
                            </v-card>
                        </v-hover>
                    </div>
                </div>
            </div>

            <div class="mt-5">
                <h2>E-mail</h2>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-start flex-wrap w-100">

                        <v-hover v-slot="{ hover }">
                            <v-card to="/configuration/senders" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>email</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes boîtes d'envois</h4>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }" v-if="!vtContract">
                            <v-card to="/configuration/email-template" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>contact_mail</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes modèles d'e-mails</h4>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }" v-if="uskaContract">
                            <v-card to="/configuration/uska-notifications" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>notifications</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes notifications Uska</h4>
                                </div>
                            </v-card>
                        </v-hover>
                    </div>
                </div>
            </div>

            <div class="mt-5" v-if="account.tis_type.code === 'APIDAE'">
                <h2>Apidae</h2>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-start flex-wrap w-100">
                        <v-hover v-slot="{ hover }" v-if="!vtContract">
                            <v-card to="/configuration/referential" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>list_alt</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mon référentiel <span v-if="account.tis_type.code === 'APIDAE'">Apidae</span></h4>
                                    <div class="d-flex gap-10 flex-wrap">
                                        <div class="badge bg-light">Catégories</div>
                                    </div>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }" v-if="account.tis_type.code === 'APIDAE'">
                            <v-card to="/configuration/apidae-projects"
                                    :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>dashboard_customize</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes projets Apidae</h4>
                                </div>
                            </v-card>
                        </v-hover>
                    </div>
                </div>
            </div>

            <div class="mt-5" v-if="!vtContract">
                <h2>Campagnes</h2>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-start flex-wrap w-100">
                        <v-hover v-slot="{ hover }" v-if="!vtContract">
                            <v-card to="/configuration/forms" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>article</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mon formulaire de mise à jour</h4>
                                    <div class="d-flex gap-10 flex-wrap">
                                        <div class="badge bg-light">Titre</div>
                                        <div class="badge bg-light">Texte d'introduction</div>
                                        <div class="badge bg-light">Personnalisation</div>
                                    </div>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }" v-if="!vtContract">
                            <v-card to="/configuration/form-template" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>feed</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes modèles de formulaires</h4>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }"
                                 v-if="hasAdhesionModule && account.configurations.adhesionV3 === null
                                 && account.cadh_configurations.length > 0 ">
                            <v-card to="/configuration/adhesion-config" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>edit_note</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mon formulaire d'adhésion</h4>
                                    <div class="d-flex gap-10 flex-wrap">
                                        <div class="badge bg-light">Titre du formulaire</div>
                                        <div class="badge bg-light">Texte d'introduction</div>
                                        <div class="badge bg-light">Champs</div>
                                        <div class="badge bg-light">Remerciements</div>
                                        <div class="badge bg-light">Titre du bulletin d'adhésion</div>
                                    </div>
                                </div>
                            </v-card>
                        </v-hover>

                        <v-hover v-slot="{ hover }"
                                 v-if="hasAdhesionModule && account.configurations.adhesionV3 !== null">
                            <v-card to="/configuration/adhesion-management" :elevation="hover ? 4 : 2">
                                <div class="card-header text-center">
                                    <v-icon x-large>list</v-icon>
                                </div>
                                <div class="p-3 card-text">
                                    <h4>Mes bulletins d'adhésion</h4>
                                    <div class="d-flex gap-10 flex-wrap">
                                        <div class="badge bg-light">Offres</div>
                                        <div class="badge bg-light">Options</div>
                                        <div class="badge bg-light">Configuration</div>
                                        <div class="badge bg-light">Remerciements</div>
                                        <div class="badge bg-light">Moyens de paiement</div>
                                    </div>
                                </div>
                            </v-card>
                        </v-hover>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"

export default {
    name: "Configuration",
    methods: {
        hasInvoiceOffer() {
            return this.account.current_contracts.find(invoiceContract =>
                invoiceContract.contract_offer.code === 'ADHESION_INVOICE')
        }
    },
    computed: {
        ...mapState('account', ['account', 'vtContract', 'uskaContract', 'hasAdhesionModule']),
        hasUskaFreemium() {
            return this.account.configurations.uskaFreemium
        }
    }
}
</script>